export var TalentPoolRoutes = {
    "/talent-pool/{brandId:[0-9]+}": {
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "component": "talentPoolContainer",
        "type": "frontend",
        "name": "appLayout.harriSH.talent-pool",
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Talent Pool"
            }
        ],
        "onEnter": ['$state', 'hUser', 'brandServices', 'userPermissions', 'hmapService', 'talentPoolDataService', '$q', function ($state, hUser, brandServices, userPermissions, hmapService, talentPoolDataService, $q) {
            if (!hUser.isEmployer()) {
                $state.go("appLayout.harriSH.dashboard");
            } else {
                var brandId = hmapService.getActiveBrand();
                if (hUser.isTopLevelContext()) {
                    brandServices.checkAll(brandId, [
                        brandServices.SERVICES.GLOBAL_TALENT_POOL,
                        brandServices.SERVICES.ONBOARDING_JOURNEY,
                    ])
                        .then(function (services) {
                            var isGlobalTalentPoolServiceEnabled = services[brandServices.SERVICES.GLOBAL_TALENT_POOL];
                            var isOnBoardingJourneyEnabled = services[brandServices.SERVICES.ONBOARDING_JOURNEY];

                            if (isOnBoardingJourneyEnabled) {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            } else if (isGlobalTalentPoolServiceEnabled) {
                                userPermissions.getBrandPolicy(brandId)
                                    .then(function (policyParser) {
                                        var hasManageTalentPoolPermission = policyParser.brands(brandId).has(userPermissions.PERMISSIONS.MANAGE_TALENT_POOL_MODULE);
                                        if (!hasManageTalentPoolPermission) {
                                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                                        }
                                    });
                            } else {
                                Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                            }
                        }, function (err) {
                            Utils.redirectToWorkspace("appLayout.harriSH.access-portal.main");
                        });
                } else {
                    var promises = {
                        canAccessTalentPool: talentPoolDataService.checkTalentPoolPermissionOnEnterpriseAndChild(),
                        isOnBoardingJourneyEnabled: brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY,hUser.getUserContext().brand_id)
                    };

                    $q.all(promises)
                        .then(function (res) {
                            var canAccessTalentPool = res.canAccessTalentPool;
                            var isOnBoardingJourneyEnabled = res.isOnBoardingJourneyEnabled;

                            if (!canAccessTalentPool || isOnBoardingJourneyEnabled) {
                                $state.go("appLayout.harriSH.dashboard");
                            }
                        });
                }
            }
        }],
        "onExit": function () {
            /* close Profile FancyBox if it's displayed */
            $.fancybox.close();
        },
        "route_dependencies": [
            {path: "d3", type: "library", "name": "d3"},
            {path: "c3", type: "library", "name": "c3"},
            {
                type: 'chunk',
                loader: function(){
                    return import("../../hmodules/talent-pool/talent-pool.module.js");
                }
            },
            // {
            //     type: 'chunk',
            //     loader: () => {
            //         // return import("../../node_modules/macy/dist/macy.js");
            //     }
            // },
        ],
        "showGlobalSearch": true,
        "loginRequired": true
    },
};
